import { isRecruiting } from "@/lib/workspace";

export default function StatsStrip({ summary, onSelect, activeKey }) {
  if (!summary) return null;
  const items = [
    { key: "active", label: "Active", value: summary.active, testId: "stats-active", accent: "#FFCB05" },
    { key: "overdue", label: "Overdue", value: summary.overdue, testId: "stats-overdue", accent: "#FCA5A5" },
    { key: "blocked", label: "Blocked", value: summary.blocked, testId: "stats-blocked", accent: "#FBC02D" },
    { key: "services_start", label: isRecruiting() ? "Hired" : "At Services Start", value: summary.services_start, testId: "stats-services-start", accent: "#A5D6A7" },
    { key: "lost", label: "Lost", value: summary.lost, testId: "stats-lost", accent: "#B0BEC5" },
  ];
  return (
    <div className="px-4 sm:px-6 lg:px-8 pt-5">
      <div className="bg-[#15233B] rounded-xl shadow-sm flex divide-x divide-white/10 overflow-hidden relative">
        <div
          aria-hidden
          className="absolute inset-0 opacity-[0.06] bg-[radial-gradient(circle_at_20%_30%,#FFCB05_0,transparent_50%),radial-gradient(circle_at_85%_70%,#1E73C9_0,transparent_50%)]"
        />
        {items.map((it) => (
          <button
            type="button"
            key={it.label}
            data-testid={it.testId}
            onClick={() => onSelect?.(it.key)}
            title={`Show ${it.label}`}
            className={`flex-1 px-5 py-4 flex items-center justify-between gap-3 relative text-left transition-colors hover:bg-white/5 focus:outline-none ${activeKey === it.key ? "bg-white/10" : ""}`}
          >
            {activeKey === it.key && (
              <span className="absolute left-0 top-0 bottom-0 w-1" style={{ backgroundColor: it.accent }} />
            )}
            <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/55">
              {it.label}
            </div>
            <div className="text-3xl font-extrabold tracking-tight tabular-nums" style={{ color: it.accent }}>
              {it.value}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
